// import React, { useState, useEffect } from "react";
// import Slider from "react-slick";
// import { Link, useNavigate } from "react-router-dom";

// const IMAGE_URL = 'https://admin.lumetiq.in/';

// const settings = {
//   dots: false,
//   infinite: true,
//   speed: 300,
//   autoplay: true,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   arrows: false,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1,
//       },
//     },
//   ],
// };

// const Prod = () => {
//   const [products, setProducts] = useState([]);
//   const navigate = useNavigate();

//   const styles = {
//     imageContainer: {
//       height: '550px',
//       width: '100%',
//       overflow: 'hidden',
//       position: 'relative'
//     },
//     image: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       position: 'absolute',
//       top: 0,
//       left: 0
//     },
//     // MODIFIED: This is now the only container you need for the slider.
//     sliderContainer: {
//       width: '100%', // Takes full width of its parent
//       maxWidth: '1320px', // Sets a max-width for large screens
//       margin: '0 auto' // This is the key to keeping it centered
//     }
//   };

//   useEffect(() => {
//     fetch('https://admin.lumetiq.in/api/products/read.php')
//       .then(response => response.json())
//       .then(data => setProducts(data.records || []))
//       .catch(error => console.error('Error fetching products:', error));
//   }, []);

//   const handleProjectClick = (id) => {
//     navigate(`/Product-details/${id}`);
//   };

// //  const dats=products.map((e)=>{return e.name})
// //  console.log(dats[2].length)
//   return (
//     <>
//       <div className="tp-blog-area-2 grey-bg-4 fix pb-90">
//         <div className="container"> {/* Using Bootstrap container for better alignment */}
//           <div className="row align-items-center">
//             <div className="col-12 col-lg-6">
//               <div className="tp-section-wrapper pb-55">
//                 <span className="tp-section-subtitle mb-25">
//                   Our Latest Products
//                 </span>
//                 <h2 className="tp-section-title">
//                   Explore our newest <br />
//                   product collection
//                 </h2>
//               </div>
//             </div>
//             {/* View More Button commented out as in original */}
//           </div>
//           <div className="row">
//             <div className="col-12">
//               {/* REMOVED the unnecessary wrapper and applied the style to this single div */}
//               <div style={styles.sliderContainer}>
//                 <Slider {...settings} >
//                   {products.map((product) => (
//                     <div key={product.id} className="slider-item-2 px-3"> {/* Added padding for spacing */}
//                       <div style={{paddingBottom: '20px'}} className="tp-blog white-bg " onClick={() => handleProjectClick(product.id)}>
//                         <div className="tp-blog__thumb" style={styles.imageContainer}>
//                           <img
//                             src={product.image_path ? `${IMAGE_URL}/${product.image_path}` : 'assets/img/project/project-details.jpg'}
//                             alt={product.name}
//                             style={styles.image}
//                           />
//                         </div>
//                         <div className="tp-blog__meta pt-25 pb-15 pl-30">
//                           <span>
//                             <a href={`/products/${product.category.toLowerCase()}`}>{product.category}</a>
//                           </span>
//                         </div>
//                         <h3 className="tp-blog__title pl-30 mb-25">
//                           <a href={`/Product-details/${product.id}`}>{product.name}</a>
//                         </h3>
//                         <a className="tp-btn-sm-black pl-30" href={`/Product-details/${product.id}`}>
//                            <span>
//                       <svg
//                         width="36"
//                         height="8"
//                         viewBox="0 0 36 8"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64644L32.1716 0.464463C31.9763 0.269201 31.6597 0.269201 31.4645 0.464463C31.2692 0.659726 31.2692 0.976308 31.4645 1.17157L34.2929 4L31.4645 6.82842C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.73079 31.9763 7.73079 32.1716 7.53553L35.3536 4.35355ZM4.37114e-08 4.5L35 4.5L35 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z"
//                           fill="currentColor"
//                         />
//                       </svg>
//                       <svg
//                         width="36"
//                         height="8"
//                         viewBox="0 0 36 8"
//                         fill="none"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64644L32.1716 0.464463C31.9763 0.269201 31.6597 0.269201 31.4645 0.464463C31.2692 0.659726 31.2692 0.976308 31.4645 1.17157L34.2929 4L31.4645 6.82842C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.73079 31.9763 7.73079 32.1716 7.53553L35.3536 4.35355ZM4.37114e-08 4.5L35 4.5L35 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z"
//                           fill="currentColor"
//                         />
//                       </svg>
//                     </span>
//                           View Details
//                         </a>
//                       </div>
//                     </div>
//                   ))}
//                 </Slider>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Prod;


import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link, useNavigate } from "react-router-dom";

const IMAGE_URL = 'https://admin.lumetiq.in/';

const settings = {
  dots: false,
  infinite: true,
  speed: 500, // Corrected speed for a smoother transition
  autoplay: false,
  autoplaySpeed: 3000, // Time between slides
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const Prod = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const styles = {
    imageContainer: {
      height: '350px',
      width: '100%',
      overflow: 'hidden',
      position: 'relative'
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0
    },
    sliderContainer: {
      width: '100%',
      maxWidth: '1320px',
      margin: '0 auto'
    },
    productCard: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: '#fff',
      cursor: 'pointer',
    },
    cardBody: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding: '10px 20px', // Restored consistent padding
    },
    // NEW: Wrapper for all content above the button
    contentWrapper: {
      flexGrow: 1, // This makes the wrapper grow, pushing the button down
    },
    // NEW: Style to handle long titles with truncation
    productTitle: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 3, // Max number of lines to show
      WebkitBoxOrient: 'vertical',
      minHeight: '55px', // Ensures space is reserved, preventing layout shifts
      // marginBottom: '9px',
    }
  };

  useEffect(() => {
    fetch('https://admin.lumetiq.in/api/products/read.php')
      .then(response => response.json())
      .then(data => setProducts(data.records || []))
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  const handleProjectClick = (id) => {
    navigate(`/Product-details/${id}`);
  };

  return (
    <>
      <div className="tp-blog-area-2 grey-bg-4 fix py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6">
              <div className="tp-section-wrapper pb-55">
                <span className="tp-section-subtitle mb-25">
                  Our Latest Products
                </span>
                <h2 className="tp-section-title">
                  Explore our newest <br />
                  product collection
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div style={styles.sliderContainer}>
                <Slider {...settings}>
                  {products.map((product) => (
                    <div key={product.id} className="slider-item-2 px-3">
                      <div style={styles.productCard} onClick={() => handleProjectClick(product.id)}>
                        <div className="tp-blog__thumb" style={styles.imageContainer}>
                          <img
                            src={product.image_path ? `${IMAGE_URL}/${product.image_path}` : 'assets/img/project/project-details.jpg'}
                            alt={product.name}
                            style={styles.image}
                          />
                        </div>
                        {/* MODIFIED: Card body with flexbox structure */}
                        <div style={styles.cardBody}>
                          {/* This wrapper grows to push the button down */}
                          <div style={styles.contentWrapper}>
                            <div className="tp-blog__meta ">
                              <span>
                                <a href={`/products/${product.category.toLowerCase()}`}>{product.category}</a>
                              </span>
                            </div>
                            {/* Title with truncation styles applied */}
                            <h4 style={styles.productTitle}>
                              <a href={`/Product-details/${product.id}`}>{product.name}</a>
                            </h4>
                          </div>
                          {/* This button will always be at the bottom */}
                         <div className="d-flex justify-content-between">
                           <a className="tp-btn-sm-black" href={`/Product-details/${product.id}`}>
                            <span className="pt-4" >
                              {/* SVG Icons */}
                              <svg className="" width="36" padding='10' height="10" viewBox="0 0 36 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64644L32.1716 0.464463C31.9763 0.269201 31.6597 0.269201 31.4645 0.464463C31.2692 0.659726 31.2692 0.976308 31.4645 1.17157L34.2929 4L31.4645 6.82842C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.73079 31.9763 7.73079 32.1716 7.53553L35.3536 4.35355ZM4.37114e-08 4.5L35 4.5L35 3.5L-4.37114e-08 3.5L4.37114e-08 4.5Z" fill="currentColor"/>
                              </svg>
                            </span>
                            View Details
                          </a>
                         </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Prod;